import { render, staticRenderFns } from "./FilesUpdown.vue?vue&type=template&id=2bc674a4&scoped=true&"
import script from "./FilesUpdown.vue?vue&type=script&lang=js&"
export * from "./FilesUpdown.vue?vue&type=script&lang=js&"
import style0 from "./FilesUpdown.vue?vue&type=style&index=0&id=2bc674a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc674a4",
  null
  
)

export default component.exports